import script from "./TirPmTextEditorFile.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20ITextEditorFile"
export * from "./TirPmTextEditorFile.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20ITextEditorFile"

import "./TirPmTextEditorFile.vue?vue&type=style&index=0&id=1a8c95ae&lang=scss"

const __exports__ = script;

export default __exports__